/* eslint-disable @atlaskit/platform/one-value-export-per-file */
import { type Context, createContext, useContext } from 'react';

import noop from 'lodash/noop';

/**
 * Shared split-view state, so the toggle in the chat header can drive the right-pane visibility owned by its ancestor `MainWrapper`
 * -without threading props between them.
 */
export type SplitViewContextValue = {
	isSplitViewOpen: boolean;
	setSplitViewOpen: (isOpen: boolean) => void;
};

export const SplitViewContext: Context<SplitViewContextValue> =
	createContext<SplitViewContextValue>({
		isSplitViewOpen: false,
		setSplitViewOpen: noop,
	});

export const useSplitView = (): SplitViewContextValue => useContext(SplitViewContext);
